// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
import { checkAccessRights } from '../utils/functions/accessRight';
import { ROLES } from '../utils/constants';
// Define a service using a base URL and expected endpoints

const USER = process.env.REACT_APP_API_URL;
const ADMIN = process.env.REACT_APP_API_URL_admin;

const baseQuery = fetchBaseQuery({
  // baseUrl: `${process.env.REACT_APP_API_URL_admin}/matchstatement`,
  baseUrl: `${
    checkAccessRights(ROLES.ADMIN_ROLE) ||
    checkAccessRights(ROLES.SUPER_ADMIN_ROLE)
      ? ADMIN
      : USER
  }/customer/manage`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const customerManageApi = createApi({
  reducerPath: 'customerManageApi',
  baseQuery,
  endpoints: (builder) => ({
    customerManage: builder.query({
      query: (q) => `/?sorgcode=${q.sorgcode}&page=${q.page}&size=${q.size}&keyword=${q.keyword}&sortBy=${q.sortBy || 'customer_no'}&sortOrder=${q.sortOrder || 'asc'}`,
    }),
  }),
});

export const { useCustomerManageQuery } = customerManageApi;
